import {Promise} from "@securionpay-internal/commons-js";
import {timeoutPromise} from "./timeoutPromise";

export const retryWhile = <T>(action: () => Promise<T>, predicate: (T) => boolean, delay: number, params: { signal?: AbortSignal }): Promise<T> => {
    const retry = <T>(): Promise<T> => {
        if (params.signal && !params.signal.aborted) {
            return Promise.reject(new DOMException('Received aborted signal', 'AbortError'));
        }

        return action().then(object => {
            if (predicate(object)) {
                return timeoutPromise(delay).then(retry);
            } else {
                return object;
            }
        })
    };
    return retry();
};